import { Id } from '@core/domain/types';

export const INVALID_ID: Id = '__invalidId__';
